module.exports = __webpack_public_path__ + "static/media/rr-mobile.ca1e35e8.png";